import Banner from '@/components/Banner2';
import { SKILL_LIST } from './index.js';
import Appointment2 from '@/components/Appointment2/index.vue';
import Title from '@/components/Title/index.vue';
import Advantages from '@/components/Advantages2/index.vue';
import FunctionCard from '@/components/FunctionCard2/index.vue';
export default {
  components: {
    Banner,
    Appointment2,
    Title,
    Advantages,
    FunctionCard
  },
  data() {
    return {
      skillList: SKILL_LIST,
      productId: this.$productId.SHOU_JI_OEM.SHOU_YE.SHOU_YE_2020,
      // 产品优势
      advantagesData: {
        leftItems: [{
          title: '安全高效',
          desc: '支持高强度的国密算法，国际算法，私有的安全通信协议，支持双因素认证，核心业务代码经历千万级日活用户多年考验'
        }, {
          title: '精细运营',
          desc: '支持360°全方位运营，可通过CBAS用户分析及KYC标签系统快速了解用户，方便运营人员针对用户进行智能营销与精准投放'
        }],
        rightItems: [{
          title: 'AI赋能',
          desc: '行业领先的语音识别、语义理解、知识图谱构建、用户画像定义、大数据挖掘分析处理等技术，带来更专业的智能服务。'
        }, {
          title: '系统开放',
          desc: '平台化定位，基于组件化架构、微服务及丰富的能力API支持，可快速的与客户合作开发，整合三方系统及模块'
        }]
      },
      // 功能card
      functionCardData: [{
        name: '丰富行情',
        desc: '提供A股、B股、港股、美股、债券、CDR、沪伦通、股指期货、外汇、股票期权、现货、基金等行情展示'
      }, {
        name: '全量交易',
        desc: '支持所有交易所要求的标准化业务，支持批量新股申购，港股通，场内基金，场外基金等交易'
      }, {
        name: '智能资讯',
        desc: '专业的财经内容生产团队，结合机器算法，提供千人千面的资讯推荐'
      }, {
        name: '智能对话',
        desc: '结合同花顺i问财，实现了客服类问题及诊股、选股类问题的智能问答'
      }, {
        name: '数据中心',
        desc: '业绩公告、国家队持股、限售解禁、增减持计划、宏观数据、等海量数据深析投资机会'
      }, {
        name: '股票F10',
        desc: 'F10可提供全面的企业资料、深入的财务解读、新鲜的公司动态等近百项功能'
      }, {
        name: '投资顾问',
        desc: '涵盖直播、文章、视频、服务包、组合、策略等多种服务，为投资顾问打造一站式线上服务平台'
      }, {
        name: '理财商城',
        desc: '可根据客户风险偏好以及过往交易自动推荐相似产品，为金融机构提供一站式金融产品线上商城'
      }, {
        name: '开户运营',
        desc: '可视化数据支持，实现开户业务优化与效率提升'
      }]
    };
  }
};